import React, { useState, useEffect } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { Link } from "react-router-dom";
import "../components/Addcart.css";
import product1 from "../assets/images/m4.png";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import FavoriteBorderOutlinedIcon from "@mui/icons-material/FavoriteBorderOutlined";
import DiscountIcon from "@mui/icons-material/Discount";
import ShoppingBagOutlinedIcon from "@mui/icons-material/ShoppingBagOutlined";
import { fetchAPI } from "../utils/api";

export default function EquipmentCart() {
  const getInitialCartData = () => {
    const saved = localStorage.getItem("selectedProductCart");
    if (saved) {
      try {
        const parsed = JSON.parse(saved);
        if (Array.isArray(parsed)) return parsed;
      } catch (e) {
        console.error("Failed to parse selectedProductCart", e);
      }
    }
    return [];
  };

  const [cartItems, setCartItems] = useState(getInitialCartData);
  const [quantities, setQuantities] = useState(() => {
    const initial = getInitialCartData();
    const initialQuants = {};
    initial.forEach((item) => {
      if (item) {
        const prodId =
          item.product_id || item.me_id || item.cart_product_id || "";
        const attrId =
          item.attribute_value_id ||
          item.id ||
          item.cart_attribute_value_id ||
          "";
        const key = item.cart_id
          ? `cart_${item.cart_id}`
          : `${prodId}_${attrId}`;
        initialQuants[key] = item.qty || 1;
      }
    });
    return initialQuants;
  });
  const [loading, setLoading] = useState(() => {
    const initial = getInitialCartData();
    return initial.length === 0 && Boolean(localStorage.getItem("user"));
  });

  const getItemKey = (item) => {
    if (!item) return "";
    if (item.cart_id) return `cart_${item.cart_id}`;
    const prodId = item.product_id || item.me_id || item.cart_product_id || "";
    const attrId =
      item.attribute_value_id || item.id || item.cart_attribute_value_id || "";
    return `${prodId}_${attrId}`;
  };

  const loadCartData = async () => {
    let items = getInitialCartData();

    if (items.length > 0) {
      setCartItems(items);
      const initialQuants = {};
      items.forEach((item) => {
        const key = getItemKey(item);
        initialQuants[key] = item.qty || 1;
      });
      setQuantities(initialQuants);
    }

    // Check if user is logged in, sync with backend API DB cart
    const userStr = localStorage.getItem("user");
    if (userStr) {
      try {
        const user = JSON.parse(userStr);
        if (user && user.user_id) {
          const apiRes = await fetchAPI("EquipmentsController/cart_list", {
            method: "POST",
            body: JSON.stringify({ user_id: user.user_id }),
          });
          if (apiRes && apiRes.status === 200) {
            if (Array.isArray(apiRes.result) && apiRes.result.length > 0) {
              items = apiRes.result.map((dbItem) => {
                const priceVal = parseFloat(
                  dbItem.cart_unit_price || dbItem.price || 0,
                );
                const secVal = parseFloat(
                  dbItem.cart_securiry_amount || dbItem.me_security_amount || 0,
                );
                return {
                  cart_id: dbItem.cart_id,
                  id: dbItem.cart_attribute_value_id || dbItem.id,
                  attribute_value_id:
                    dbItem.cart_attribute_value_id || dbItem.id,
                  product_id: dbItem.cart_product_id || dbItem.product_id,
                  name: dbItem.me_product_name || dbItem.name,
                  duration:
                    dbItem.attribute?.attribute_value ||
                    dbItem.duration ||
                    "Standard Plan",
                  price: priceVal,
                  security_amount: secVal,
                  image: dbItem.me_image || dbItem.image || "/placeholder.png",
                  type: "equipment",
                  qty: parseInt(dbItem.cart_qty || dbItem.qty || 1),
                };
              });
              localStorage.setItem(
                "selectedProductCart",
                JSON.stringify(items),
              );
            } else {
              // DB cart is empty (e.g. after order placement), clear local storage!
              items = [];
              localStorage.removeItem("selectedProductCart");
            }
          }
        }
      } catch (err) {
        console.error("Error syncing cart with DB:", err);
      }
    }

    setCartItems(items);

    const initialQuants = {};
    items.forEach((item) => {
      const key = getItemKey(item);
      initialQuants[key] = item.qty || 1;
    });
    setQuantities(initialQuants);
    setLoading(false);
  };

  useEffect(() => {
    loadCartData();
    window.addEventListener("cartUpdated", loadCartData);
    return () => {
      window.removeEventListener("cartUpdated", loadCartData);
    };
  }, []);

  const getQuantity = (item) => {
    if (!item) return 1;
    const key = getItemKey(item);
    return quantities[key] !== undefined ? quantities[key] : item.qty || 1;
  };

  const inc = (item) => {
    const key = getItemKey(item);
    setQuantities((prev) => ({
      ...prev,
      [key]: (prev[key] !== undefined ? prev[key] : item.qty || 1) + 1,
    }));
  };

  const dec = (item) => {
    const key = getItemKey(item);
    setQuantities((prev) => {
      const current = prev[key] !== undefined ? prev[key] : item.qty || 1;
      if (current <= 1) return prev;
      return {
        ...prev,
        [key]: current - 1,
      };
    });
  };

  const handleDelete = async (targetItem) => {
    const targetKey = getItemKey(targetItem);
    const updated = cartItems.filter((item) => getItemKey(item) !== targetKey);
    setCartItems(updated);
    if (updated.length > 0) {
      localStorage.setItem("selectedProductCart", JSON.stringify(updated));
    } else {
      localStorage.removeItem("selectedProductCart");
    }

    const userStr = localStorage.getItem("user");
    if (userStr && targetItem.cart_id) {
      try {
        const user = JSON.parse(userStr);
        if (user && user.user_id) {
          await fetchAPI("EquipmentsController/delete_cart", {
            method: "POST",
            body: JSON.stringify({
              user_id: user.user_id,
              cart_id: targetItem.cart_id,
            }),
          });
        }
      } catch (err) {
        console.error("Error deleting item from DB cart:", err);
      }
    }

    window.dispatchEvent(new Event("cartUpdated"));
  };

  const parsePrice = (priceStr) => {
    if (typeof priceStr === "number") return priceStr;
    if (!priceStr) return 0;
    const num = parseFloat(
      String(priceStr)
        .replace(/,/g, "")
        .replace(/[^\d.]/g, ""),
    );
    return isNaN(num) ? 0 : num;
  };

  const subtotal = cartItems.reduce((acc, item) => {
    return acc + parsePrice(item.price) * getQuantity(item);
  }, 0);

  const securityTotal = cartItems.reduce((acc, item) => {
    const sec = parsePrice(
      item.security_amount || item.me_security_amount || item.security || 0,
    );
    return acc + sec * getQuantity(item);
  }, 0);

  const tax = Math.round(subtotal * 0.05 * 100) / 100; // 5% GST
  const total = subtotal + securityTotal + tax;

  return (
    <>
      <Header />

      <div className="test_bredcum_sec">
        <div className="container-fluid">
          <div className="test_bredcum">
            <Link to="/">Home</Link>
            <span>&gt;</span>
            <Link to="/product-on-rent">Products on Rent</Link>
            <span>&gt;</span>
            <span className="name_p"> Cart</span>
          </div>
        </div>
      </div>

      <div className="cart_section_content">
        <div className="container-fluid">
          {loading && cartItems.length === 0 ? (
            <div className="text-center py-5 bg-light rounded-3 my-3">
              <div
                className="spinner-border text-primary"
                role="status"
                style={{ color: "#13505b" }}
              >
                <span className="visually-hidden">Loading cart...</span>
              </div>
              <p className="mt-3 text-muted">Checking your cart...</p>
            </div>
          ) : cartItems.length === 0 ? (
            <div className="text-center py-5 bg-light rounded-3 my-3">
              <h3 style={{ marginBottom: "15px", color: "#13505b" }}>
                Your Equipment Cart is Empty
              </h3>
              <p className="text-muted mb-4">
                Explore our range of ICU beds, oxygen concentrators, and medical
                devices on rent.
              </p>
              <Link
                to="/product-on-rent"
                className="btn text-white fw-bold px-4 py-2"
                style={{
                  backgroundColor: "#13505b",
                  borderRadius: "25px",
                  textDecoration: "none",
                }}
              >
                Go to Products on Rent
              </Link>
            </div>
          ) : (
            <div className="row">
              <div className="col-lg-7 col-md-7 col-12">
                <div className="add_cart_right_sec">
                  <div className="addcart_header">
                    <h3 className="mb-0 fw-bold" style={{ color: "#13505b" }}>
                      <ShoppingBagOutlinedIcon className="me-2" />
                      Product in Cart
                    </h3>
                  </div>

                  <div className="add_cart_box equipment_addcart">
                    {cartItems.map((item) => {
                      const priceNumber = parsePrice(item.price);
                      const securityAmount = parsePrice(
                        item.security_amount ||
                          item.me_security_amount ||
                          item.security ||
                          0,
                      );
                      const durationStr = item.duration
                        ? String(item.duration).toLowerCase()
                        : "";
                      const key = getItemKey(item);

                      return (
                        <div className="main_box_crd_section" key={key}>
                          <div className="row align-items-center">
                            <div className="col-lg-9 col-md-8 col-12">
                              <div className="img_price_cart">
                                <div className="row align-items-center">
                                  <div className="col-3">
                                    <div className="img_cart">
                                      <img
                                        src={item.image || product1}
                                        alt={item.name}
                                        style={{
                                          maxWidth: "100%",
                                          objectFit: "contain",
                                        }}
                                      />
                                    </div>
                                  </div>

                                  <div className="col-9">
                                    <div className="text_price_cart">
                                      {/* <span className="badge bg-light text-dark border mb-1">
                                        Rent Duration:{" "}
                                        {item.duration || "Standard Plan"}
                                      </span> */}
                                      <h5 className="fw-bold text-dark">
                                        {item.name}
                                      </h5>

                                      <div className="main_price_cart">
                                        <div className="d-flex align-items-baseline gap-1">
                                          <h4
                                            className="fw-bold mb-0"
                                            style={{ color: "#13baac" }}
                                          >
                                            ₹{priceNumber}
                                          </h4>
                                          {durationStr && (
                                            <span
                                              className="text-muted small"
                                              style={{
                                                fontSize: "14px",
                                                textTransform: "lowercase",
                                              }}
                                            >
                                              / {durationStr}
                                            </span>
                                          )}
                                        </div>
                                        {securityAmount > 0 && (
                                          <div
                                            className="text-muted small mt-1"
                                            style={{
                                              fontSize: "13px",
                                              textTransform: "lowercase",
                                            }}
                                          >
                                            (security amount: ₹{securityAmount})
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="col-lg-3 col-md-4 col-12">
                              <div className="medicine_cart_de delete_add_section d-flex align-items-center justify-content-between justify-content-md-end gap-3">
                                <div className="counter d-flex align-items-center border rounded">
                                  <button
                                    type="button"
                                    className="btn btn-sm btn-light px-2"
                                    onClick={() => dec(item)}
                                  >
                                    -
                                  </button>
                                  <span className="px-3 fw-bold">
                                    {getQuantity(item)}
                                  </span>
                                  <button
                                    type="button"
                                    className="btn btn-sm btn-light px-2"
                                    onClick={() => inc(item)}
                                  >
                                    +
                                  </button>
                                </div>

                                <button
                                  type="button"
                                  className="btn cross-btn "
                                  title="Remove item"
                                  onClick={() => handleDelete(item)}
                                >
                                  X
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>

              <div className="col-lg-5 col-md-5 col-12 mt-4 mt-md-0">
                <div className="offer_and_discont_sec">
                  <div className="summary_sec booking_box add_card_detail">
                    <h4
                      className="fw-bold summary-heading"
                      style={{ color: "#13505b" }}
                    >
                      Cart Summary
                    </h4>

                    <div className="price_booking">
                      {cartItems.map((item) => {
                        const itemPriceTotal =
                          parsePrice(item.price) * getQuantity(item);
                        const key = getItemKey(item);
                        return (
                          <div
                            className="name_price_booking d-flex justify-content-between align-items-start mb-2"
                            key={key}
                          >
                            <div>
                              <h6 className="fw-bold mb-0 text-dark">
                                {item.name || item.me_product_name}
                              </h6>
                              <span className="text-muted small">
                                Duration: {item.duration || "Standard Plan"} |
                                Qty: {getQuantity(item)}
                              </span>
                            </div>
                            <strong className="text-dark">
                              ₹ {itemPriceTotal.toFixed(2)}
                            </strong>
                          </div>
                        );
                      })}

                      <div className="name_price_booking d-flex justify-content-between  pt-2 border-top">
                        <span> Subtotal</span>
                        <strong className="text-dark">
                          ₹ {subtotal.toFixed(2)}
                        </strong>
                      </div>
                      <div className="name_price_booking d-flex justify-content-between ">
                        <span>Refundable Security Deposit</span>
                        <strong className="text-dark">
                          ₹ {securityTotal.toFixed(2)}
                        </strong>
                      </div>
                      <div className="name_price_booking d-flex justify-content-between ">
                        <span>GST (5%)</span>
                        <strong className="text-dark">
                          ₹ {tax.toFixed(2)}
                        </strong>
                      </div>
                    </div>

                    <div className="total_price_booking d-flex justify-content-between pt-3 mb-4">
                      <h5 className="fw-bold text-dark mb-0">Total</h5>
                      <h4 className="fw-bold mb-0" style={{ color: "#13505b" }}>
                        ₹ {total.toFixed(2)}
                      </h4>
                    </div>

                    <div className="btns_add_crd_detail d-grid gap-2 ">
                      <Link
                        to="/medicinecheckout"
                        className="btn btn-lg text-white py-2 text-center"
                        style={{
                          backgroundColor: "#13505b",
                          borderRadius: "8px",
                        }}
                      >
                        Proceed to Checkout
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      <Footer />
    </>
  );
}
